// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Pill } from 'lucide-react';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-12 pb-6">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Link to="/" className="flex items-center space-x-2">
  <img
    src="/images/pharma_logo.webp"
    alt="K.K. Pharmaceuticals Logo"
    className="h-8 w-8 object-contain"
  />
 <span className="text-teal-500 font-semibold text-md">
  K.K. Pharmaceuticals
</span>
</Link>
            </div>
            <p className="text-sm leading-relaxed">
              Trusted pharmaceutical dealership in Gondia, Maharashtra. Providing quality medicines and healthcare products since establishment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-teal-500 transition">Home</Link></li>
              <li><Link to="/about" className="hover:text-teal-500 transition">About Us</Link></li>
              <li><Link to="/products" className="hover:text-teal-500 transition">Products</Link></li>
              <li><Link to="/contact" className="hover:text-teal-500 transition">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-teal-500 mt-0.5" />
                <span className="text-sm">Kk Complex, At-Thana, Amgaon, Gondia, Maharashtra - 441902</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-teal-500" />
                <span className="text-sm">+91 7972285589</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-teal-500" />
                <span className="text-sm">kkpharma44@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Business Hours</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-3">
                <Clock size={18} className="text-teal-500" />
                <span className="text-sm">Mon - Sat: 9:00 AM - 5:00 PM</span>
              </li>
              <li className="flex items-center space-x-3">
                <Clock size={18} className="text-teal-500" />
                <span className="text-sm">Sunday: Closed</span>
              </li>
            </ul>
            <div className="flex space-x-3 mt-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-500 transition">
                <FaFacebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-500 transition">
                <FaInstagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-500 transition">
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} K.K. Pharmaceuticals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;